import $ from "jquery";

$(".accordion-question").on("click", function() {
  $(this).toggleClass("show");
});
